module.exports = __webpack_public_path__ + "static/media/dialogue.80e016fc.svg";